export default __webpack_public_path__ + "static/media/alert.38502bd8.ogg";